import { createFileRoute } from '@tanstack/react-router';
import { SopsPage } from '@/features/sops/pages/sops-page';

export const Route = createFileRoute('/_app/sops/')({ component: SopsPage });
